export enum TeamDialog {
  Editor,
  Refresh,
  Restore,
}
